import { SizableText, Stack, XStack, YStack } from '@my/ui'
import { RichText } from 'app/components'
import { ChevronDown, ChevronUp } from '@tamagui/lucide-icons'
import { useState } from 'react'
import { FaqsBlock } from './faqs.block'

export type FaqsItemProps = FaqsBlock['faqs'][0]

export const FaqsItem = (props: FaqsItemProps) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <YStack py="$2" width="100%" borderBottomWidth={2} borderColor="$gray7" $gtSm={{ py: '$3' }}>
      <XStack
        flex={1}
        justifyContent="space-between"
        onPress={() => setIsOpen(!isOpen)}
        cursor="pointer"
        alignItems="center"
        width="100%"
      >
        <SizableText
          color="$overlay12"
          size="$4"
          fow="600"
          numberOfLines={1}
          width="90%"
          $gtSm={{ size: '$5', fow: '600' }}
        >
          {props.question}
        </SizableText>
        {!isOpen ? <ChevronDown size={30} /> : <ChevronUp size={30} />}
      </XStack>
      {isOpen && (
        <Stack pt="$2">
          <RichText color="$overlay11" content={props.answer} />
        </Stack>
      )}
    </YStack>
  )
}
